<div class="settings-workflow-editor">
  <header>
    <h3>EDIT WORKFLOW STAGES AND TRANSITIONS</h3>
  </header>
    <settings-workflows-workflow-editor
        [workflow]="workflow"
    ></settings-workflows-workflow-editor>
</div>


